var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 199,
    viewBox: "0 0 256 199",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m118.431947 187.698037c32.890056-5.8101 60.055363-10.617957 60.367362-10.684121l.567276-.120304-31.051455-36.934731c-17.078287-20.314105-31.05144-37.0135-31.05144-37.109763 0-.182257 32.06325-88.4775168 32.243499-88.791861.060266-.104805 21.880281 37.566853 52.893149 91.318807 29.034814 50.323542 52.972611 91.815483 53.195106 92.204295l.404552.706942-98.684084-.012729-98.6840664-.012677 59.8001014-10.563822zm-118.43195104-11.263314c0-.052002 14.63129504-25.450782 32.51398844-56.441754l32.5139832-56.3472172 37.8912894-31.7984466c20.840208-17.4891418 37.94741-31.81982192 38.015996-31.84667602.068586-.02541214-.205562.66458386-.609219 1.53405261-.403657.86946874-18.91873 40.58235031-41.1446072 88.25084461l-40.4106754 86.6699876-29.3853777.036841c-16.1619541.020284-29.38537774-.005691-29.38537774-.057652z",
    fill: "#0089d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftAzure);
export default __webpack_public_path__ + "static/media/microsoft-azure.2727f4305b41592886ed62516f61f910.svg";
export { ForwardRef as ReactComponent };